var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"products"},[_c('h2',{staticClass:"products__title"},[_vm._v(_vm._s(_vm.$t('productsTitle')))]),_c('div',{staticClass:"products__items"},_vm._l((_vm.products),function(product){return _c('product-component',{key:product.title,attrs:{"product":product}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }